(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["laverne-whatsapp-chat"] && !Shopify.designMode) return;
  try {
    (function () {
    var whatsappSelector = [
      'a[href*="wa.me/"]',
      'a[href*="api.whatsapp.com"]',
      'a[href*="whatsapp.com/send"]'
    ].join(',');

    function normalizeSource(value) {
      return String(value || 'whatsapp_link')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '')
        .slice(0, 80) || 'whatsapp_link';
    }

    function getSource(link) {
      var explicitSource = link.getAttribute('data-whatsapp-source');
      if (explicitSource) return normalizeSource(explicitSource);

      if (link.closest('footer')) return 'footer';

      return normalizeSource(
        link.getAttribute('aria-label') ||
        link.textContent ||
        'whatsapp_link'
      );
    }

    function trackWhatsAppClick(link) {
      var source = getSource(link);
      var eventParameters = {
        method: 'whatsapp',
        link_source: source,
        page_path: window.location.pathname,
        page_title: document.title
      };

      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
      ) {
        window.Shopify.analytics.publish('whatsapp_click', eventParameters);
      }

      if (typeof window.gtag === 'function') {
        window.gtag('event', 'whatsapp_click', eventParameters);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'whatsapp_click',
          method: eventParameters.method,
          link_source: eventParameters.link_source,
          page_path: eventParameters.page_path,
          page_title: eventParameters.page_title
        });
      }

      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', 'WhatsAppClick', {
          source: source,
          page_path: window.location.pathname
        });
      }
    }

    if (!window.__laverneWhatsappTrackingReady) {
      window.__laverneWhatsappTrackingReady = true;

      document.addEventListener('click', function (event) {
        var target = event.target;
        if (!target || typeof target.closest !== 'function') return;

        var link = target.closest(whatsappSelector);
        if (!link) return;

        trackWhatsAppClick(link);
      }, true);
    }

    var chat = document.querySelector('[data-laverne-whatsapp]');
    if (!chat) return;

    var menu = chat.querySelector('#laverne-whatsapp-menu');
    var toggles = chat.querySelectorAll('[data-laverne-whatsapp-toggle]');
    var firstOption = chat.querySelector('.laverne-whatsapp__option');

    function setOpen(isOpen, moveFocus) {
      chat.classList.toggle('is-open', isOpen);
      chat.classList.remove('is-prompt-visible');
      menu.setAttribute('aria-hidden', String(!isOpen));

      toggles.forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', String(isOpen));
      });

      if (isOpen && moveFocus && firstOption) {
        window.setTimeout(function () {
          firstOption.focus();
        }, 60);
      }
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        setOpen(!chat.classList.contains('is-open'), true);
      });
    });

    document.addEventListener('click', function (event) {
      if (!chat.classList.contains('is-open')) return;
      if (chat.contains(event.target)) return;
      setOpen(false, false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !chat.classList.contains('is-open')) return;
      setOpen(false, false);
      var primaryToggle = chat.querySelector('.laverne-whatsapp__button');
      if (primaryToggle) primaryToggle.focus();
    });

    var storageKey = 'laverne_whatsapp_prompt_shown';
    var wasShown = false;

    try {
      wasShown = window.sessionStorage.getItem(storageKey) === '1';
    } catch (error) {
      wasShown = false;
    }

    if (wasShown) return;

    window.setTimeout(function () {
      if (!chat.classList.contains('is-open')) {
        chat.classList.add('is-prompt-visible');
      }

      try {
        window.sessionStorage.setItem(storageKey, '1');
      } catch (error) {
        return;
      }

      window.setTimeout(function () {
        chat.classList.remove('is-prompt-visible');
      }, 12000);
    }, 10000);
  })();
  } catch(e) { console.error(e); }
})();

})();
